import React, {Component} from "react";
import { Link } from 'react-router-dom';

import Constants from "../../../constants/constants";


import 'react-tippy/dist/tippy.css';
import {Tooltip} from 'react-tippy';
import { withWhiteLabelContext } from 'react-whitelabel';

class PlayScreenCard extends Component {
    onClick() {
        const {card_data, token} = this.props;

        

        if (card_data.is_external) {
            let port = window.location.port;
            let platformURL = "https://" + window.location.hostname;

            if (port !== "") {
                platformURL += ":" + port;
            }
            platformURL = encodeURIComponent(platformURL);
            window.location = Constants.getPlayContentUrl() + card_data.view + "&auth=" + token + "&purl=" + platformURL;
            return;
        }
        else {
            if (card_data.view !== "") {
                this.props.history.push(card_data.view);
            }    
        }
    }

    render() {
        const {card_data, locked, label} = this.props;
        const content = label.playScreen;
        const title = content[card_data.titleId];
        const tooltip = card_data.tooltip;
        const iconData = card_data.icon_data;
        const color = card_data.color;
        let cardClass = card_data.card_class;

        let comingSoon = false;
        if (card_data.coming_soon) {
            comingSoon = true;
        }
        
        const bottomTitle = card_data.bottom_title;
        const borderRadius = card_data.border_radius;

        let iconPath = "";
        if (iconData) {
            iconPath = iconData.path;
        }

        let titleStyle = {
            "background": color,
            "color": "white",
            
        }

        cardClass += " play_screen_card";


        
        let cardStyle = {
            borderRadius: borderRadius
        };

        let titleClass = 'play_screen_card_title_section top_title';
        let iconClass = 'play_screen_card_icon_container top_title';
        if (bottomTitle) {
            titleClass = ' play_screen_card_title_section bottom_title';
            iconClass = 'play_screen_card_icon_container bottom_title';
        }


        if (comingSoon) {
            cardClass += " coming_soon";
            iconClass += " coming_soon";
            titleClass += " coming_soon";
        }

        if (locked) {
            cardClass += " locked";
            iconClass += " locked";
            titleClass += " locked";
        }

        let comingSoonBanner = (<div className='coming_soon_banner'>Coming Soon!</div>)

        
        let titleSection = (
            <div className={titleClass} style={titleStyle}>
                <div className='play_screen_card_title'>{title}</div>
                <Tooltip className='play_screen_card_tooltip' title={tooltip}>
                    <img alt='tooltip_icon' className='play_screen_card_tooltip_icon' src={require(`../../../static/assets/play-screen-icons/info.svg`)}></img>
                </Tooltip>
            </div>
        );

        //const isExternal = card_data.isExternal;
        if (locked) {
            return (
                <div className={cardClass} style={cardStyle}>
                    {!bottomTitle && titleSection}
                    <div className={iconClass}>                        
                        <img alt="play_screen_icon"  className='play_screen_card_icon' src={require(`../../../static/assets/play-screen-icons/${iconPath}`)}/>
                    </div> 
                    {bottomTitle && titleSection}
                </div>
            )
            
        }
        else if (card_data.is_external) {
            return (
                <div onClick={this.onClick.bind(this)} className={cardClass} style={cardStyle}>
                    {!bottomTitle && titleSection}
                    <div className={iconClass}>                        
                        <img alt="play_screen_icon"  className='play_screen_card_icon' src={require(`../../../static/assets/play-screen-icons/${iconPath}`)}/>
                    </div> 
                    {bottomTitle && titleSection}
                </div>
            )
        }
        else {
            return (
            <Link to={card_data.view} className={cardClass} style={cardStyle}>
                {!bottomTitle && titleSection}
                <div className={iconClass}>
                    <img alt="play_screen_icon" className='play_screen_card_icon' src={require(`../../../static/assets/play-screen-icons/${iconPath}`)}/>
                </div> 
                {comingSoon && comingSoonBanner}
                {bottomTitle && titleSection}
            </Link>
        )
        }
        
    }
}

export default withWhiteLabelContext(PlayScreenCard);



// WEBPACK FOOTER //
// ./src/components/containers/play-screen/play-screen-card.js